import $ from 'jquery';
import { removeLocalstorageLogout, sleep } from '../helper';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';

const showModalPremium = async (show = true, waitModalOpen = false) => {
  if (show) {
    $('#modal-premium').modal({
      keyboard: false,
      backdrop: 'static',
    });
  }
  else {
    if (waitModalOpen) {
      await sleep(500)
    }
    $('#modal-premium').modal('hide')
  }

};

const MySwal = withReactContent(Swal);

const showMAPErrorLogin = () => {
  MySwal.fire({
    icon: 'error',
    title: 'MAP tidak bisa login',
    text: 'Tolong kontak admin',
    confirmButtonText: 'Refresh',
    allowOutsideClick: false,
  }).then(({ isConfirmed }) => {
    if (isConfirmed) {
      if (localStorage.getItem('token')) {
        localStorage.removeItem('token')
      }
      window.location.reload();
    }
  });
}

const showLoginSuccess = async () => {
  return MySwal.fire({
    title: 'Login Berhasil',
    icon: 'success',
    text: 'Selamat menikmati layanan MAP',
  });
}

const showLoginError = async (msgError) => {
  return MySwal.fire({
    title: 'Login tidak berhasil',
    icon: 'error',
    text: msgError,
  });
}

const showModalUserError = async () => {
  const { isConfirmed } = await MySwal.fire({
    title: 'User tidak berhasil diambil',
    icon: 'error',
    text: 'Silahkan menghubungi admin',
    allowOutsideClick: false,
    allowEscapeKey: false,
    confirmButtonText: 'Refresh'
  });

  if (isConfirmed) {
    removeLocalstorageLogout()
    window.location.reload()
  }
}

export { showModalPremium, showMAPErrorLogin, showLoginSuccess, showModalUserError, showLoginError };
